import React from 'react';
import '../styles/playerStats.css';

export default function PlayerStats() {
  return (
    <div id="playerStats">
      <h1>ADDISALEM SEIFU</h1>
      <div id="playerStats__lines">
        <span id="playerStats__lines__thick" />
        <span id="playerStats__lines__thin" />
      </div>
      <h2>Full-stack Web Developer</h2>
    </div>
  );
}
